<app-pageheader [Parent]="this">
</app-pageheader>

<div class="container">
  <h3 class="has-text-centered">
    <i>Welcome to your Integrations management page. <br/>
      If any settings or integrations are not present here, make sure to check the Settings Page.</i>
  </h3>
</div>